import { Tooltip, Typography } from '@mui/material';

// Single-line, ellipsised text. `tooltip` surfaces the full value on hover for columns whose
// content routinely runs past the cell, such as file paths and process paths.
const TruncatedText = ({
  value,
  fallback = '—',
  muted = false,
  bold = false,
  fontSize = '0.7rem',
  tooltip = false,
}) => {
  const text = (
    <Typography
      variant="caption"
      sx={{
        fontSize,
        fontWeight: bold ? 600 : 400,
        color: muted ? '#9CA3AF' : '#F3F4F6',
        display: 'block',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}>
      {value || fallback}
    </Typography>
  );

  if (!tooltip || !value) {
    return text;
  }

  return (
    <Tooltip
      title={value}
      arrow
      placement="top-start"
      componentsProps={{
        tooltip: { sx: { bgcolor: '#3F3F3F', maxWidth: 520, wordBreak: 'break-all' } },
      }}>
      {text}
    </Tooltip>
  );
};

export default TruncatedText;
